import Vue from 'vue'
import Preloader from '@/components/preloader/Preloader'

Vue.prototype.$preloader = new Vue({
  data: () => ({
    show: true
  }),
  methods: {
    start () {
      document.body.classList.add('preload')
      this.show = true
    },
    stop () {
      document.body.classList.remove('preload')
      this.show = false
    }
  }
})

Vue.component('Preloader', Preloader)
